/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Nav_Packaging_MasterInputs */

const vi_pkl_nav_packaging_master = /** @type {(inputs: Pkl_Nav_Packaging_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư + BOM (master)`)
};

/**

* @param {Pkl_Nav_Packaging_MasterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_nav_packaging_master = /** @type {((inputs?: Pkl_Nav_Packaging_MasterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Nav_Packaging_MasterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_nav_packaging_master(inputs)
});